<template>
  <div>
    <BasicTableComponent 
      v-if="!showOnlyTotal"
      :list="dailyRowsWithTotal" 
      :hideColumns="['ts_from', 'ts_to']"
      :formatters="{
        'credit_txns' : ['n', '0,0'],
        'debit_txns' : ['n', '0,0'],
        'total_txns' : ['n', '0,0'],
        'credit_sales' : ['n', '0,0.00'],
        'debit_sales' : ['n', '0,0.00'],
        'total_sales' : ['n', '0,0.00'],
        'credit_txn_pct' : ['n', '0.00'],
        'credit_sales_pct' : ['n', '0.00'],
        'avg_ticket_credit' : ['n', '0,0.00'],
        'avg_ticket_debit' : ['n', '0,0.00'],
      }"
      :titles="{
        'summary_date' : 'Date',
        'credit_txns' : 'Credit<br>Txns',
        'debit_txns' : 'Debit<br>Txns',
        'total_txns' : 'Total<br>Txns',
        'credit_sales' : 'Credit<br>Sales',
        'debit_sales' : 'Debit<br>Sales',
        'total_sales' : 'Total<br>Sales',
        'credit_txn_pct' : 'Credit<br>Txn %',
        'credit_sales_pct' : 'Credit<br>Sales %',
        'avg_ticket_credit' : 'Avg Ticket<br>Credit',
        'avg_ticket_debit' : 'Avg Ticket<br>Debit',
      }" 
      
    />
    
    <!-- Monthly Total Table - Always shows the total row -->
    <table style="width:700px">
      <tr>
        <th>Period</th>
        <th>Credit Txns</th>
        <th>Debit Txns</th>
        <th>Total Txns</th>
        <th>Credit Sales</th>
        <th>Debit Sales</th>
        <th>Total Sales</th>
        <th>Credit Txn %</th>
        <th>Credit Sales %</th>
        <th>Avg Ticket Credit</th>
        <th>Avg Ticket Debit</th>
      </tr>
      
      <tr v-if="!papStore.data[location].isLoading && totalRow" :style="{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }">
        <td style="text-align:right">{{D(totalRow.ts_from, 'MMM-YYYY')}}</td>
        <td style="text-align:right">{{F(totalRow.credit_txns, '0,0')}}</td>
        <td style="text-align:right">{{F(totalRow.debit_txns, '0,0')}}</td>
        <td style="text-align:right">{{F(totalRow.total_txns, '0,0')}}</td>
        <td style="text-align:right">{{F(totalRow.credit_sales)}}</td>
        <td style="text-align:right">{{F(totalRow.debit_sales)}}</td>
        <td style="text-align:right">{{F(totalRow.total_sales)}}</td>
        <td style="text-align:right">{{F(totalRow.credit_txn_pct, '0.00')}}</td>
        <td style="text-align:right">{{F(totalRow.credit_sales_pct, '0.00')}}</td>
        <td style="text-align:right">{{F(totalRow.avg_ticket_credit)}}</td>
        <td style="text-align:right">{{F(totalRow.avg_ticket_debit)}}</td>
      </tr>
    </table>
  </div>


</template>

<script>
import formatDataMixin from '@/mixins/formatDataMixin.js'
export default {
  
  inject: ['papCreditVsDebitPage'],
  props: ['location'],
  mixins : [formatDataMixin],
  computed:{
    papStore(){
      return this.papCreditVsDebitPage.$refs.papCreditVsDebitStore
    },
    creditVsDebitData(){
      return this.papStore.data && this.papStore.data[this.location] ? this.papStore.data[this.location].creditVsDebit : undefined;
    },
    isLoading(){
      return this.papStore.data[this.location].isLoading;
    },
    showOnlyTotal(){
      return this.papCreditVsDebitPage.showOnlyTotal;
    },
    dailyRows(){
      if (!this.creditVsDebitData || !Array.isArray(this.creditVsDebitData)) return [];
      // Return all rows except the last one (which is the total)
      return this.creditVsDebitData.slice(0, -1);
    },
    dailyRowsWithTotal(){
      if (!this.creditVsDebitData || !Array.isArray(this.creditVsDebitData)) return [];
      // Return all rows including the total for the BasicTableComponent
      return this.creditVsDebitData;
    },
    totalRow(){
      if (!this.creditVsDebitData || !Array.isArray(this.creditVsDebitData)) return null;
      // Return the last row which should be the total
      const lastRow = this.creditVsDebitData[this.creditVsDebitData.length - 1];
      return lastRow && lastRow.summary_date === 'Total' ? lastRow : null;
    }
  },
  methods: {
    // No additional methods needed
  }
  

}
</script>

<style lang="scss" scoped>

</style>
